import ActionTypes from "./constants";
import { ContainerState, ContainerActions } from './types';

const initialState = {
  jobSubmitted: [],
  productsDownloaded: []
};

const cartReducer = (state: ContainerState = initialState, action: ContainerActions): ContainerState => {
  switch (action.type) {
    case ActionTypes.JOBS_SUBMITTED:
      return { ...state, jobSubmitted: state.jobSubmitted.concat(action.payload) };
    case ActionTypes.DOWNLOADED_PRODUCTS:
      return { ...state, productsDownloaded: state.productsDownloaded.concat(action.payload) };
    default:
      return state
  }
};
export default cartReducer;
